export function createClearButton({ title, onClear }) {
  const btn = document.createElement("button")
  btn.type = "button"
  btn.title = title
  
  // Base classes (colors, rounds, transitions)
  btn.className = "rounded text-on-surface-muted transition-colors outline-none cursor-pointer flex items-center justify-center"
  
  // Base inline styles
  btn.style.cssText = [
    "width: 20px",
    "height: 20px",
    "background: transparent",
    "border: none"
  ].join(";")
  
  btn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`
  
  btn.addEventListener("mouseenter", () => {
    btn.style.color = "var(--color-on-surface)"
    btn.style.background = "var(--color-surface-100)"
  })
  
  btn.addEventListener("mouseleave", () => {
    btn.style.color = "var(--color-on-surface-muted)"
    btn.style.background = "transparent"
  })

  if (onClear) {
    btn.addEventListener("click", onClear)
  }

  return btn
}
